import {Component} from '@angular/core';
import {NavController} from 'ionic-angular';
import {GVLogger} from "../../services/gv-logger";


@Component({
  selector: 'page-customer-wish-list',
  templateUrl: 'customer-wish-list.html'
})
export class CustomerWishListPage {


  constructor(public nav: NavController, private gVLogger: GVLogger) {

  }

  // get discount percent
  discountPercent(originPrice, salePrice) {
    return Math.round((salePrice - originPrice) * 100 / originPrice)
  }

}



// WEBPACK FOOTER //
// ./src/pages/customer-wish-list/customer-wish-list.ts